import Vue from 'vue';
export default Vue.extend({
    name: 'massConvertConfirmSpotPopupChunk',
    props: {
        slotData: {
            type: Object,
            required: true
        }
    },
    computed: {
        totalBNB() {
            const totalSum = this.slotData.items.reduce((acc, item) => {
                return acc + parseFloat(item.val);
            }, 0);
            return String(totalSum);
        }
    }
});
